'use client';

import NavSearch from 'builder/components/elements/NavSearch';
import { SearchBarVariant } from 'builder/components/elements/NavSearchElements/searchUtils';
import { type JSX, useState } from 'react';
import { getSearchUrl, SearchFilterContentTypes, type SearchOrigins } from 'search-gateway-client';

interface TopNavSearchBarProps {
    onCollapse?: () => void;
    showCloseButton?: boolean;
}

export default function TopNavSearchBar({ onCollapse, showCloseButton }: TopNavSearchBarProps): JSX.Element {
    const [showSuggestions, setShowSuggestions] = useState(false);

    const handleSubmit = (
        contentType: SearchFilterContentTypes,
        searchValue: string,
        searchOrigin: SearchOrigins,
    ): void => {
        const searchUrl = getSearchUrl({
            contentType,
            searchTerm: searchValue,
            searchOrigin,
        });
        window.location.href = searchUrl;
    };

    return (
        <NavSearch
            contentType={SearchFilterContentTypes.All_videos_content_type}
            onSubmit={handleSubmit}
            userHasAnySubscription={false}
            isEnterpriseMember={false}
            pproPluginEnabled={false}
            isSearchAppLoaded={(): boolean => true}
            imagesUrl=""
            showSuggestions={showSuggestions}
            setShowSuggestions={setShowSuggestions}
            // StockBlocks always shows Snapshots (SnapshotsFlag is hard-enabled); keep the shell nav in parity.
            useSnapshots
            searchBarVariant={SearchBarVariant.TopNav}
            className="lg:w-full"
            compact
            onCollapse={onCollapse}
            showCloseButton={showCloseButton}
        />
    );
}
